var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0516 6.22959L4.78878 14.4714C3.93312 14.8552 3.64372 15.6239 4.58197 16.041L10.0368 17.7835L23.2259 9.5902C23.9461 9.07584 24.6833 9.213 24.0489 9.77883L12.7212 20.0883L12.3654 24.4512C12.695 25.1248 13.2985 25.128 13.6834 24.7932L16.8174 21.8124L22.1848 25.8524C23.4314 26.5943 24.1098 26.1156 24.378 24.7558L27.8985 7.99945C28.264 6.32578 27.6407 5.58834 26.0516 6.22959Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegram);
export default __webpack_public_path__ + "static/media/IconTelegram.7ca7ad3e1d08ca23089b4b1b30400f75.svg";
export { ForwardRef as ReactComponent };